/**
 * Português neutro — idioma base da aplicação.
 * `pt-BR.ts` e `pt-PT.ts` sobrescrevem apenas o que muda.
 */
export const pt = {
  'app.tagline': 'Joguem as cartas em ordem crescente. Sem combinar nada.',
  'app.version': 'versão {version}',

  'common.back': 'Voltar',
  'common.cancel': 'Cancelar',
  'common.close': 'Fechar',
  'common.confirm': 'Confirmar',
  'common.continue': 'Continuar',
  'common.loading': 'Carregando…',
  'common.you': 'você',
  'common.online': 'Conectado',
  'common.offline': 'Sem conexão',
  'common.connecting': 'Conectando…',
  'common.reconnecting': 'Reconectando…',
  'common.optional': 'opcional',

  'home.create': 'Criar jogo',
  'home.join': 'Entrar no jogo',
  'home.howToPlay': 'Como jogar',
  'home.intro':
    'De 2 a 8 pessoas. Cada uma vê apenas as próprias cartas e todas precisam jogar na ordem certa.',

  'create.title': 'Criar jogo',
  'create.nickname': 'O teu apelido',
  'create.nicknamePlaceholder': 'Como queres ser chamado?',
  'create.capacity': 'Capacidade da sala',
  'create.capacityHint': 'As regras são definidas com quem estiver presente no início.',
  'create.rules': 'Configuração de regras',
  'create.rulesRecommended': 'Recomendada',
  'create.rulesCustom': 'Personalizada',
  'create.submit': 'Criar sala',
  'create.creating': 'Criando…',

  'join.title': 'Entrar no jogo',
  'join.code': 'Código da sala',
  'join.codePlaceholder': 'AB2CD3',
  'join.nickname': 'O teu apelido',
  'join.submit': 'Entrar',
  'join.joining': 'Entrando…',
  'join.codeHint': '6 caracteres, sem distinção entre maiúsculas e minúsculas.',

  'lobby.title': 'Sala de espera',
  'lobby.code': 'Código',
  'lobby.link': 'Link da sala',
  'lobby.copy': 'Copiar link',
  'lobby.copied': 'Link copiado',
  'lobby.share': 'Compartilhar',
  'lobby.qr': 'Mostrar QR code',
  'lobby.qrTitle': 'Aponte a câmera',
  'lobby.qrHint': 'O QR code abre direto esta sala.',
  'lobby.players': 'Jogadores ({count}/{capacity})',
  'lobby.host': 'anfitrião',
  'lobby.remove': 'Remover {name}',
  'lobby.settings': 'Regras',
  'lobby.advanced': 'Avançado',
  'lobby.recommended': 'Preset recomendado',
  'lobby.recommendedHint': 'Nível final e vidas calculados pelo número de jogadores.',
  'lobby.maxLevel': 'Último nível',
  'lobby.startingLives': 'Vidas iniciais',
  'lobby.sound': 'Som',
  'lobby.vibration': 'Vibração',
  'lobby.start': 'Começar',
  'lobby.startHint': 'É preciso ter pelo menos 2 jogadores conectados.',
  'lobby.leave': 'Sair da sala',
  'lobby.waitingHost': 'Aguardando o anfitrião começar…',
  'lobby.summary': 'Níveis 1–{maxLevel} · Vidas: {lives} · Estrelas: {stars}',

  'game.level': 'Nível',
  'game.levelOf': 'Nível {level} de {maxLevel}',
  'game.lives': 'Vidas',
  'game.stars': 'Estrelas',
  'game.room': 'Sala',
  'game.cards': '{count} cartas',
  'game.cardsOne': '1 carta',
  'game.cardsNone': 'sem cartas',
  'game.dropHere': 'Solte aqui',
  'game.pileEmpty': 'A pilha está vazia',
  'game.played': '{count} jogadas',
  'game.yourHand': 'Sua mão',
  'game.playCard': 'Jogar carta {value}',
  'game.playCardShort': 'Jogar carta',
  'game.confirmPlay': 'Confirmar jogada',
  'game.refocus': 'Pausar e recentralizar',
  'game.refocusShort': 'Recentralizar',
  'game.star': 'Pedir estrela',
  'game.waitingServer': 'Confirmando…',
  'game.dragHint': 'Arraste a carta destacada até o centro.',
  'game.notYourTurn': 'Só a menor carta da sua mão pode ser jogada.',
  'game.emptyHand': 'Você já jogou todas as suas cartas.',

  'timer.interval': 'Desde a última carta',
  'timer.total': 'Tempo do nível',

  'phase.DEALING': 'Distribuindo as cartas…',
  'phase.READY': 'Preparação do nível',
  'phase.COUNTDOWN': 'Preparar…',
  'phase.REFOCUS': 'Recentralizando',
  'phase.STAR_VOTE': 'Votação de estrela',
  'phase.RESOLVING_STAR': 'Estrela usada',
  'phase.RESOLVING_ERROR': 'Fora de ordem',
  'phase.LEVEL_COMPLETE': 'Nível concluído',
  'phase.CONNECTION_PAUSED': 'Partida pausada',

  'ready.title': 'Nível {level}',
  'ready.body': 'Olhe suas cartas. Quando todos estiverem prontos, a contagem começa.',
  'ready.action': 'Estou pronto',
  'ready.waiting': 'Aguardando: {names}',
  'ready.allReady': 'Todos prontos!',

  'countdown.go': 'Já!',

  'star.title': 'Usar uma estrela?',
  'star.body': '{name} pediu uma estrela. Cada pessoa descarta a menor carta da mão.',
  'star.yes': 'Sim',
  'star.no': 'Não',
  'star.pending': 'Faltam votar: {names}',
  'star.waiting': 'Aguardando os outros votos…',
  'star.approvedTitle': 'Estrela usada',
  'star.approvedBody': 'Estas cartas saíram das mãos:',
  'star.rejectedTitle': 'Estrela cancelada',
  'star.rejectedBody': 'A votação precisa ser unânime.',
  'star.none': 'Sem estrelas disponíveis',
  'star.seen': 'Já vi',
  'star.seenWaiting': 'Aguardando os outros…',
  'star.waitingSeen': 'Faltam ver: {names}',
  'star.allSeen': 'Todos já viram!',

  'error.title': 'Fora de ordem',
  'error.body': '{name} jogou a carta {value}, mas ainda havia cartas menores.',
  'error.lostLife': 'A equipe perdeu 1 vida.',
  'error.discarded': 'Cartas descartadas:',

  'reward.starTitle': 'Estrela conquistada',
  'reward.lifeTitle': 'Vida conquistada',
  'reward.capped': 'A equipe já estava no máximo.',

  'level.title': 'Nível {level} concluído',
  'level.cards': 'Cartas jogadas',
  'level.errors': 'Erros no nível',
  'level.time': 'Tempo total',
  'level.average': 'Intervalo médio',
  'level.next': 'Ir para o nível {level}',
  'level.byPlayer': 'Cartas de cada jogador',
  'level.noCards': 'nenhuma carta',
  'level.legend': 'Verde: jogada na ordem certa · Vermelho: fora de ordem · Riscada: carta perdida',

  'won.title': 'Sincronia perfeita',
  'won.body': 'Vocês concluíram todos os {levels} níveis.',
  'won.again': 'Jogar novamente',
  'won.levels': 'Níveis concluídos',
  'won.cards': 'Cartas jogadas',
  'won.errors': 'Erros',
  'won.stars': 'Estrelas usadas',
  'won.time': 'Tempo de jogo',

  'lost.title': 'A sequência quebrou',
  'lost.body': 'As vidas acabaram no nível {level}.',
  'lost.back': 'Voltar à sala',

  'paused.title': 'Partida pausada',
  'paused.body': '{name} perdeu a conexão. A mão fica guardada até voltar.',
  'paused.bodyGeneric': 'Alguém perdeu a conexão. A partida continua quando todos voltarem.',
  'paused.deadline': 'Aguardando reconexão…',
  'paused.end': 'Encerrar partida',
  'paused.endHint': 'Disponível depois da janela de reconexão.',
  'paused.reconnect': 'Reconectando você…',

  'howto.title': 'Como jogar',
  'howto.goalTitle': 'Objetivo',
  'howto.goal':
    'Joguem todas as cartas na pilha central em ordem crescente. Ninguém pode dizer quais cartas tem.',
  'howto.turnsTitle': 'Sem turnos',
  'howto.turns':
    'Não existe ordem de jogada. Qualquer pessoa pode jogar a qualquer momento — só a menor carta da própria mão.',
  'howto.errorsTitle': 'Erros',
  'howto.errors':
    'Se alguém jogar uma carta maior do que uma carta que ainda está em outra mão, a equipe perde 1 vida e todas as cartas menores são descartadas.',
  'howto.starTitle': 'Estrela',
  'howto.star':
    'A estrela precisa de votação unânime. Quando aprovada, cada pessoa descarta a menor carta da mão.',
  'howto.timerTitle': 'Cronômetro',
  'howto.timer':
    'O cronômetro mostra o tempo desde a última carta aceita e é igual para todos. Ele reinicia a cada jogada e fica pausado nas telas de votação, erro e preparação.',
  'howto.installTitle': 'Instalar no celular',
  'howto.install':
    'Abra o menu do navegador e escolha "Adicionar à tela de início" para usar em tela cheia.',

  'errors.VALIDATION_FAILED': 'Verifique os dados informados.',
  'errors.RATE_LIMITED': 'Muitas tentativas seguidas. Aguarde alguns segundos.',
  'errors.ROOM_NOT_FOUND': 'Não encontramos uma sala com esse código.',
  'errors.ROOM_FULL': 'Esta sala já está cheia.',
  'errors.ROOM_ALREADY_STARTED': 'A partida já começou nesta sala.',
  'errors.ROOM_CLOSED': 'A sala foi encerrada.',
  'errors.INVALID_CODE': 'Código inválido. São 6 caracteres.',
  'errors.NAME_TAKEN': 'Já existe alguém com esse apelido na sala.',
  'errors.NAME_INVALID': 'Escolha um apelido entre 2 e 20 caracteres.',
  'errors.NOT_IN_ROOM': 'Você não está mais nesta sala.',
  'errors.NOT_HOST': 'Apenas o anfitrião pode fazer isso.',
  'errors.NOT_ENOUGH_PLAYERS': 'É preciso ter pelo menos 2 jogadores conectados.',
  'errors.INVALID_PHASE': 'Esta ação não está disponível agora.',
  'errors.INVALID_CONFIG': 'Configuração inválida para esta sala.',
  'errors.CARD_NOT_FOUND': 'Carta não encontrada.',
  'errors.CARD_NOT_PLAYABLE': 'Só é possível jogar a menor carta da sua mão.',
  'errors.STALE_ACTION': 'Essa carta não está mais na sua mão.',
  'errors.NO_STARS_LEFT': 'Não há estrelas disponíveis.',
  'errors.STAR_VOTE_ACTIVE': 'Já existe uma votação em andamento.',
  'errors.ALREADY_VOTED': 'Você já votou.',
  'errors.PLAYER_NOT_FOUND': 'Jogador não encontrado.',
  'errors.SESSION_INVALID': 'Sua sessão expirou. Entre novamente.',
  'errors.CANNOT_END_GAME_YET': 'Ainda dá tempo de esperar a reconexão.',
  'errors.INTERNAL_ERROR': 'Algo deu errado. Tente novamente.',
  'errors.CONNECTION': 'Sem conexão com o servidor.',
} as const;

export type MessageKey = keyof typeof pt;
export type Messages = Record<MessageKey, string>;
